import {Vector2, Vector2MetaField} from '@cascade/core';
import {useSubscribableValue} from '../../hooks';
import {NumberInput} from '../controls';
import {MetaFieldGroup} from './MetaFieldGroup';
import styles from '../controls/Controls.module.scss';

export interface Vector2MetaFieldViewProps {
  field: Vector2MetaField;
}

export function Vector2MetaFieldView({field}: Vector2MetaFieldViewProps) {
  const value = useSubscribableValue(field.onChanged);
  const presets = field.getPresets();

  const matchIndex = presets.findIndex(p => {
    const v = new Vector2(p.value);
    return v.x === value.x && v.y === value.y;
  });

  return (
    <MetaFieldGroup field={field}>
      {presets.length > 0 && (
        <select
          className={styles.select}
          value={matchIndex}
          onChange={e => {
            const idx = parseInt((e.target as HTMLSelectElement).value);
            if (idx >= 0) {
              field.set(presets[idx].value);
            }
          }}
        >
          {matchIndex < 0 && <option value={-1}>Custom</option>}
          {presets.map((p, i) => (
            <option key={i} value={i}>
              {p.text}
            </option>
          ))}
        </select>
      )}
      <NumberInput value={value.x} onChange={x => field.set([x, value.y])} />
      <NumberInput value={value.y} onChange={y => field.set([value.x, y])} />
    </MetaFieldGroup>
  );
}
